import * as urls from "./url";
import client, { getHeader } from "../client";
import { interceptor, substituteEncrypted } from "../../util/util";

export const dashboardCount = (payload) => interceptor(() => client.post(urls.VCCP_DASHBOARD_COUNT, substituteEncrypted(payload), getHeader()));
